<script setup>
const props = defineProps([
  "name",
  "division",
  "subtitleTag",
  "role",
  "mobile",
  "mobileUrl",
  "phone",
  "phoneUrl",
  "email",
  "imageUrl",
  "location",
]);

const getSubtitleTagClass = (tag) => {
  if (!tag) {
    return "";
  }

  const normalizedTag = tag.toLowerCase();

  if (normalizedTag.includes("cyber")) {
    return "subtitle-tag-cyber";
  }

  if (normalizedTag.includes("d&o") || normalizedTag.includes("d and o")) {
    return "subtitle-tag-do";
  }

  return "subtitle-tag-default";
};
</script>

<template>
  <div
    class="card underwriters col-4 col-md-2 my-2 mr-1 animate__animated animate__fadeIn"
  >
    <img
      class="card-img-top"
      :src="require(`@/assets/img/pen/${imageUrl}.jpg`)"
      alt="Card image cap"
    />
    <div class="card-body">
      <h5 class="card-title name highlight mb-2">{{ name }}</h5>
      <p v-if="!subtitleTag" class="division mb-2">{{ division }}</p>
      <p
        v-if="subtitleTag"
        class="subtitle-tag mb-2"
        :class="getSubtitleTagClass(props.subtitleTag)"
      >
        {{ subtitleTag }}
      </p>
      <p class="m-0">
        <em>{{ role }}</em>
      </p>
      <!-- <p class="m-0">
        <a :href="`tel:${mobileUrl}`">{{ mobile }}</a>
      </p> -->
      <p class="m-0">
        <a :href="`tel:${phoneUrl}`">{{ phone }}</a>
      </p>
      <p class="m-0">
        <a :href="`mailto:${email}`">Email</a>
      </p>
    </div>
  </div>
</template>
